export const catchUpHeaderLabel = "HOTx3b";
export const headlinesHeaderLabel = "YbLAW";
export const highPriorityViewLabel = "phn3Zd";
export default {catchUpHeaderLabel,headlinesHeaderLabel,highPriorityViewLabel};